import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {positionT} from '@/lib/types/position.types';

interface POSITION_STATE {
  positions: positionT[];
  isLoading: boolean;
  error: string | null;
}

const POSITION_INITIAL: POSITION_STATE = {
  positions: [],
  isLoading: false,
  error: null,
};

const positionSlice = createSlice({
  name: 'position',
  initialState: {
    ...POSITION_INITIAL,
  },
  reducers: {
    POSITION_UPDATE: (state, action: PayloadAction<{data?: POSITION_STATE; prop?: string; value?: string | Date}>) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {POSITION_UPDATE} = positionSlice.actions;

export {positionSlice, POSITION_INITIAL, POSITION_UPDATE};
